import { useContext, useEffect, useState } from "react";
import { Box, CircularProgress, Container, FormControlLabel, Grid, Paper } from "@mui/material";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useTranslation } from "react-i18next";
import { getMenus, getAll, updateOrder, updateActive } from "./services/api";
import { SnackbarGlobal } from "components/Snackbar";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { Android12Switch, StyledMenu } from "components/Styled";
import ReactInstaStories from "./modules/ReactInstaStories";
import ToolBar from "components/ToolBar";
import { FMPageOpacityTransition } from "components/FMTransitions/PageTransitions";
import { AuthContext } from "context/AuthContext";
import { BranchOfficeSelectOnPage } from "components/BranchOfficesSelect/BranchOfficeSelect";
import { ActionFabButtonAdd, ActionsDialogPage, ActionsMenuPage } from "./ActionsPage";
import { DraggableRowButtonMenu, DraggableRowDragIndicatorIcon, DraggableRowText } from "components/Builder/DraggableRow";
import LoaderSwitch from "components/Loaders/LoaderSwitch";
import { getActive } from "./routeHelpers";
import MenusList from "routes/Builder/modules/MenusList";

export default function MenuDesign() {
  const { t } = useTranslation();
  const { branchOfficeSelected } = useContext(AuthContext)
  const [dataMenus, setDataMenus] = useState(null)
  const [menuIdSelected, setMenuIdSelected] = useState(null);
  const [dataFilter, setDataFilter] = useState(null)
  const [openAction, setOpenAction] = useState(0) // 0: close, 1: add, 2: edit, 3: delete, 4: copy
  const [notification, setNotification] = useState({ open: false, message: "", severity: "" })
  const [instanceSelected, setInstanceSelected] = useState(null)
  const [showStories, setShowStories] = useState(true)
  const [loadingUpdateActive, setLoadingUpdateActive] = useState(false)
  const [itemIdToUpdateActive, setItemIdToUpdateActive] = useState(null)
  const queryClient = useQueryClient()
  const { isFetching, data: dataMenusList } = useQuery('menusPromotionList', getMenus, { refetchOnWindowFocus: false })
  const { data: dataPromotions } = useQuery(
    ['promotionList', menuIdSelected], () => getAll(menuIdSelected),
    { refetchOnWindowFocus: false, enabled: menuIdSelected !== null && menuIdSelected !== undefined }
  )

  useEffect(() => {
    queryClient.invalidateQueries('menusPromotionList')
    setInstanceSelected(null)
    setDataFilter(null)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branchOfficeSelected])

  useEffect(() => {
    if (dataMenusList !== undefined && dataMenusList !== null && dataMenusList !== "") {
      setDataMenus(dataMenusList.data)
      document.addEventListener("wheel", function (event) {
        if (document.activeElement.type === "number") { document.activeElement.blur(); }
      });
    }
  }, [dataMenusList])

  useEffect(() => {
    if (dataPromotions !== undefined && dataPromotions !== null && dataPromotions !== "") {
      setDataFilter(dataPromotions.data)
      setShowStories(true)
    }
  }, [dataPromotions])

  const handleRefreshData = () => { setShowStories(false); queryClient.invalidateQueries('promotionList') }
  const handleResetActions = () => { setOpenAction(0) }
  const handleWatchAction = (success, message, severity) => {
    setNotification({ open: true, message: message, severity: severity })
    if (success) { handleRefreshData(); handleResetActions() }
  }

  const handleMenuSelected = (id) => { setMenuIdSelected(id) }

  const [anchorElMenuActions, setAnchorElMenuActions] = useState(null)
  const open = Boolean(anchorElMenuActions)
  const handleClickMenuActions = (event, item) => {
    setAnchorElMenuActions(event.currentTarget); setInstanceSelected(item);
  }
  const handleCloseMenuActions = () => setAnchorElMenuActions(null)
  const handleMenuItemClick = (option) => { setOpenAction(option); handleCloseMenuActions(); }

  const handleSearch = (e) => {
    const dataFilter = dataPromotions.data.filter(item => item.name.toLowerCase().includes(e.target.value.toLowerCase(), 0))
    setDataFilter(dataFilter)
  }

  const mutation = useMutation(updateOrder, {
    onSuccess: (data) => {
      if (data.status === "error") { } else { queryClient.invalidateQueries('promotionList') }
    }
  })

  const handlerOrder = (params) => { mutation.mutate({ menuId: menuIdSelected, params: params }) }

  /* Drag and Drop */
  const handleDrop = (droppedItem) => {
    if (!droppedItem.destination) return;
    var orderDND = dataFilter
    const [reorderedItem] = orderDND.splice(droppedItem.source.index, 1);
    orderDND.splice(droppedItem.destination.index, 0, reorderedItem);
    setDataFilter(orderDND)
    let order = []
    orderDND.forEach((element, index) => { order.push({ id: element._id, order: index }) });
    handlerOrder(order)
  }

  const mutationActive = useMutation(updateActive, {
    onSuccess: (data) => {
      setLoadingUpdateActive(false)
      setItemIdToUpdateActive(null)
      if (data.status === "error") {
        handleWatchAction(false, 'Error al guardar los datos', 'error')
      } else {
        queryClient.invalidateQueries('promotionList')
        handleWatchAction(true, 'Acción realizada correctamente', 'success')
      }
    }
  })

  const handleUpdateActive = (item) => {
    setLoadingUpdateActive(true)
    setItemIdToUpdateActive(item._id)
    let params = !item.active
    mutationActive.mutate({ id: item._id, menuId: menuIdSelected, params: params })
  }

  if (branchOfficeSelected === null) { return <BranchOfficeSelectOnPage /> }

  return (<FMPageOpacityTransition>
    <Box component="main" style={{ marginBottom: 100 }}>
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <MenusList data={dataMenus} loading={isFetching} instanceSelected={menuIdSelected} selectInstance={handleMenuSelected} />
        {(dataFilter !== null) && <>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12} md={7}>
              <Paper sx={{ padding: 3 }}>
                <div className="toolbar_container"> <ToolBar searchFunction={handleSearch} /> </div>
                <DragDropContext onDragEnd={handleDrop}>
                  <Droppable droppableId="droppable">
                    {(provided) => (
                      <Grid container spacing={2} className="droppable" {...provided.droppableProps} ref={provided.innerRef}>
                        {dataFilter.map((item, index) => (<>
                          <Draggable key={item._id} draggableId={item._id} index={index}>
                            {(provided) => (
                              <Grid key={`${index}-${item._id}`} item xs={12} ref={provided.innerRef} /* {...provided.dragHandleProps} */ {...provided.draggableProps}>
                                <Grid container spacing={0} sx={{ padding: "10px 0px", alignItems: "center", borderTop: "1px solid rgba(224, 224, 224, 1)" }}>
                                  <Grid item xs={1} {...provided.dragHandleProps}>
                                    <DraggableRowDragIndicatorIcon disabled={false} />
                                  </Grid>
                                  <Grid item xs={3}> <DraggableRowText text={item.name} /> </Grid>
                                  <Grid item xs={4}> <DraggableRowText text={<div style={{ fontSize: 14 }}>
                                    <div><b>Inicio Vigencia:</b> <br /> {item.validity_start_datetime}</div>
                                    <div><b>Fin Vigencia:</b> <br /> {item.validity_end_datetime}</div>
                                  </div>} /> </Grid>
                                  <Grid item xs={3} sx={{ display: "flex", justifyContent: "end", alignItems: "center" }}>
                                    <DraggableRowButtonMenu
                                      open={open}
                                      disabled={false}
                                      action={(event) => handleClickMenuActions(event, item)} />
                                    {(loadingUpdateActive && itemIdToUpdateActive === item._id) ?
                                      <LoaderSwitch on={getActive(item._id, dataFilter)} /> :
                                      <FormControlLabel sx={{ marginRight: 0 }} control={<Android12Switch checked={item.active} disabled={false} onClick={() => handleUpdateActive(item)} />} />
                                    }
                                  </Grid>
                                </Grid>
                              </Grid>)}
                          </Draggable>
                        </>))}
                        {provided.placeholder}
                      </Grid>
                    )}
                  </Droppable>
                </DragDropContext>
              </Paper>
            </Grid>
            <Grid item xs={12} md={5} className="stories-preview-container">
              {(dataFilter !== null && showStories) ? <ReactInstaStories data={dataFilter}/> : <CircularProgress />}
            </Grid>
          </Grid>
        </>}
      </Container>
    </Box>
    {(dataFilter !== null) ? <>
      <ActionFabButtonAdd t={t} action={() => setOpenAction(1)} />
      <ActionsDialogPage
        open={openAction}
        close={() => setOpenAction(0)}
        menu={menuIdSelected}
        menuList={dataMenus}
        instance={instanceSelected}
        reportAction={handleWatchAction} />
      <StyledMenu id="demo-customized-menu"
        anchorEl={anchorElMenuActions}
        open={open}
        onClose={handleCloseMenuActions}
        MenuListProps={{ 'aria-labelledby': 'demo-customized-button' }}>
        <ActionsMenuPage t={t} action={handleMenuItemClick} />
      </StyledMenu>
    </> : null}
    <SnackbarGlobal
      open={notification.open}
      close={() => setNotification({ ...notification, open: false, message: "" })}
      message={notification.message}
      severity={notification.severity} />
  </FMPageOpacityTransition>)
}